import { Form, Grid } from "antd";
import { FC, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { useDebounce } from "src/hooks/useDebounce";
import { useLazyGetHotelsAndCitesQuery } from "src/store/slices/hotels/Hotels";
import { HotelSelectOptionType, mapOption } from "./utils";
import HotelSelectWeb from "./layouts/HotelSelect.web";
import HotelSelectMob from "./layouts/HotelSelect.mob";

const HotelSelectComponent = withConditionalComponent(HotelSelectWeb, HotelSelectMob);

const HotelSelect: FC<any> = ({ value, onChange, label, icon, className, onFinishSelect, ...rest }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [searchValue, setSearchValue] = useState<string>();
  const [getHotels, { isFetching, error }] = useLazyGetHotelsAndCitesQuery();
  const [options, setOptions] = useState<HotelSelectOptionType[]>([]);
  const errors = Form.Item.useStatus().errors;
  const justSelectedRef = useRef(false);

  useDebounce(searchValue, {
    skipFirstRender: true,
    delay: 500,
    callBack: () => {
      if (justSelectedRef.current) {
        justSelectedRef.current = false;
        return;
      }
      if (!searchValue) return setOptions([]);
      getHotels({
        query: searchValue,
      }).then((res)=>{
        setOptions(res?.data?.results?.map(mapOption) ?? []);
      })
    },
  });

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const handleChange = (val: any) => {
    justSelectedRef.current = true;
    setSearchValue(val?.label);
    onChange?.(val);
    onFinishSelect?.();
  };

  const sharedProps = {
    value,
    onChange: handleChange,
    label,
    icon,
    className,
    error,
    options,
    isFetching,
    searchValue,
    validationError: errors,
    onSearch: handleSearch,
    ...rest,
  };

  return <HotelSelectComponent trigger={isLargeScreen} props={sharedProps} />;
};

export default HotelSelect;
